/**
 * When the bundle on screen was built.
 *
 * A push to `main` is a production deploy and the browser holds index.html
 * across one, so "I loaded it and nothing happened" has meant a stale bundle
 * rather than a fault in the code being discussed (2026-09-19: a save that had
 * shipped three minutes earlier). `appVersion` is a constant and cannot tell
 * two builds apart. This can.
 *
 * ITS OWN MODULE, zero imports, because appConfig.ts THROWS at import time
 * when the AAD env vars are absent — which is every test run. A pure function
 * that cannot be tested is not much of a pure function.
 */

/** Baked in by vite.config.ts. Absent under a bare `tsc` run. */
declare const __BUILT_AT__: string | undefined;

/**
 * "19 Sep 12:05" in the reader's own timezone, or "" when there is no stamp.
 *
 * EMPTY, never a guess. The whole point is to settle an argument about which
 * code is running, and a made-up build time settles it wrongly.
 *
 * TAKES ITS ARGUMENT, with no default that reads the constant. Vitest loads
 * vite.config.ts, so `__BUILT_AT__` is defined during tests too — a default
 * parameter would have made the absent-stamp branch unreachable from a test,
 * which is the branch most worth pinning.
 */
export function builtAtLabel(iso: string | undefined): string {
  if (!iso) return "";
  const t = new Date(iso);
  if (Number.isNaN(t.getTime())) return "";
  return t.toLocaleString(undefined, {
    day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit",
  });
}

/** This bundle's own stamp, formatted. "" when it was not baked in. */
export function builtAt(): string {
  return builtAtLabel(typeof __BUILT_AT__ === "string" ? __BUILT_AT__ : undefined);
}
